import React, { Children } from 'react';
import { Link } from 'react-router-dom';
export function PrivacyPolicy() {
  const infoPages = [{
    name: 'FAQs',
    path: '/12.html'
  }, {
    name: 'Compliance',
    path: '/Compliance'
  }, {
    name: 'Screen Printing Advice',
    path: '/Screen-Printing-Advice'
  }, {
    name: 'What is Vector Art?',
    path: '/What-is-Vector-Art'
  }, {
    name: 'The Wear Haus Way',
    path: '/The-Wear-Haus-Way'
  }, {
    name: 'Terms and Conditions',
    path: '/Terms'
  }, {
    name: 'Privacy Policy',
    path: '/Privacy'
  }];
  return <div className="flex flex-col w-full" data-id="element-554">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-16" data-id="element-555">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-556">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-557">
            Privacy Policy
          </h1>
          <p className="text-xl text-white/90" data-id="element-558">
            How We Protect Your Information
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50" data-id="element-559">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-560">
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-561">
            {/* Sidebar Navigation */}
            <aside className="lg:w-64 flex-shrink-0" data-id="element-562">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-24" data-id="element-563">
                <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-564">
                  Helpful Info
                </h3>
                <nav className="space-y-2" data-id="element-565">
                  {infoPages.map(page => <Link key={page.path} to={page.path} className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${page.path === '/Privacy' ? 'bg-wh-pink text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-566">
                      {page.name}
                    </Link>)}
                </nav>
              </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1" data-id="element-567">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-568">
                <div className="prose prose-lg max-w-none" data-id="element-569">
                  <p className="text-gray-700 mb-6" data-id="element-570">
                    This privacy policy has been compiled to better serve those
                    who are concerned with how their 'Personally Identifiable
                    Information' (PII) is being used online. PII, as used in US
                    privacy law and information security, is information that
                    can be used on its own or with other information to
                    identify, contact, or locate a single person, or to identify
                    an individual in context. Please read our privacy policy
                    carefully to get a clear understanding of how we collect,
                    use, protect or otherwise handle your Personally
                    Identifiable Information in accordance with our website.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-571">
                    What personal information do we collect from the people that
                    visit our blog, website or app?
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-572">
                    When appropriate, you may be asked to enter your name, email
                    address, mailing address, phone number or other details to
                    help you with your experience.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-573">
                    When do we collect information?
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-574">
                    We collect information from you when you subscribe to a
                    newsletter, fill out a form or enter information on our
                    site.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-575">
                    How do we use your information?
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-576">
                    We may use the information we collect from you when you
                    register, make a purchase, sign up for our newsletter,
                    respond to a survey or marketing communication, surf the
                    website, or use certain other site features in the following
                    ways:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-gray-700" data-id="element-577">
                    <li data-id="element-578">To quickly process your transactions.</li>
                    <li data-id="element-579">
                      To send periodic emails regarding your order or other
                      products and services.
                    </li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-580">
                    How do we protect visitor information?
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-581">
                    Our website is scanned on a regular basis for security holes
                    and known vulnerabilities in order to make your visit to our
                    site as safe as possible.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-582">
                    We do not use Malware Scanning.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-583">
                    Your personal information is contained behind secured
                    networks and is only accessible by a limited number of
                    persons who have special access rights to such systems, and
                    are required to keep the information confidential.
                  </p>
                  <p className="text-gray-700 mb-6" data-id="element-584">
                    We implement a variety of security measures when a user
                    enters, submits, or accesses their information to maintain
                    the safety of your personal information.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-585">
                    Do we use 'cookies'?
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-586">
                    We do not use cookies for tracking purposes, but rather to
                    make your browsing experience as fluid as possible.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-587">
                    You can choose to have your computer warn you each time a
                    cookie is being sent, or you can choose to turn off all
                    cookies. You do this through your browser (like Google
                    Chrome) settings. Each browser is a little different, so
                    look at your browser's Help menu to learn the correct way to
                    modify your cookies.
                  </p>
                  <p className="text-gray-700 mb-6" data-id="element-588">
                    If you disable cookies, some features will be disabled that
                    make your site experience more efficient and some of our
                    services will not function properly.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-589">
                    Third Party Disclosure
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-590">
                    We do not sell, trade, or otherwise transfer to outside
                    parties your personally identifiable information.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-591">
                    Third party links
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-592">
                    We do feature a few outbound links to partner websites. We
                    are not responsible for any activity that occurs as a result
                    of clicking these links as we have no control over the
                    content of the websites linked.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-593">
                    Google
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-594">
                    Google's advertising requirements can be summed up by
                    Google's Advertising Principles. They are put in place to
                    provide a positive experience for users. For more
                    information about Google's policies, click here.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-595">
                    Google, as a third party vendor, uses cookies to serve ads
                    on our site. Google's use of the DART cookie enables it to
                    serve ads to our users based on their visit to our site and
                    other sites on the Internet. Users may opt out of the use of
                    the DART cookie by visiting the Google ad and content
                    network privacy policy.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-596">
                    We have implemented the following:
                  </p>
                  <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-597">
                    <li data-id="element-598">Remarketing with Google AdSense</li>
                    <li data-id="element-599">Google Display Network Impression Reporting</li>
                    <li data-id="element-600">Demographics and Interests Reporting</li>
                  </ul>
                  <p className="text-gray-700 mb-4" data-id="element-601">
                    We, along with third-party vendors such as Google, use
                    first-party cookies (such as the Google Analytics cookies)
                    and third-party cookies (such as the DoubleClick cookie) or
                    other third-party identifiers together to compile data
                    regarding user interactions with ad impressions, and other
                    ad service functions as they relate to our website.
                  </p>
                  <p className="text-gray-700 mb-6" data-id="element-602">
                    <strong data-id="element-603">Opting out:</strong> Users can set preferences for
                    how Google advertises to you using the Google Ad Settings
                    page. Alternatively, you can opt out by visiting the Network
                    Advertising initiative opt out page or permanently using the
                    Google Analytics Opt Out Browser add on.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-604">
                    California Online Privacy Protection Act
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-605">
                    CalOPPA is the first state law in the nation to require
                    commercial websites and online services to post a privacy
                    policy. The law's reach stretches well beyond California to
                    require a person or company in the United States (and
                    conceivably the world) that operates websites collecting
                    personally identifiable information from California
                    consumers to post a conspicuous privacy policy on its
                    website stating exactly the information being collected and
                    those individuals with whom it is being shared, and to
                    comply with this policy. – Learn more here.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-606">
                    According to CalOPPA we agree to the following:
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-607">
                    Users can visit our site anonymously. Once this privacy
                    policy is created, we will add a link to it on our home
                    page, or as a minimum on the first significant page after
                    entering our website. Our Privacy Policy link includes the
                    word 'Privacy', and can be easily be found on the page
                    specified above.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-608">
                    Users will be notified of any privacy policy changes:
                  </p>
                  <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-609">
                    <li data-id="element-610">On our Privacy Policy Page</li>
                  </ul>
                  <p className="text-gray-700 mb-6" data-id="element-611">
                    Users are able to change their personal information:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-gray-700" data-id="element-612">
                    <li data-id="element-613">By emailing us</li>
                    <li data-id="element-614">By calling us</li>
                  </ul>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-615">
                    How does our site handle "do not track" signals?
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-616">
                    We honor "do not track" signals and do not track, plant
                    cookies, or use advertising when a "Do Not Track" browser
                    mechanism is in place.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-617">
                    Does our site allow third party behavioral tracking?
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-618">
                    We do not allow third party behavioral tracking.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-619">
                    COPPA (Children Online Privacy Protection Act)
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-620">
                    When it comes to the collection of personal information from
                    children under 13, the Children's Online Privacy Protection
                    Act (COPPA) puts parents in control. The Federal Trade
                    Commission, the nation's consumer protection agency,
                    enforces the COPPA Rule, which spells out what operators of
                    websites and online services must do to protect children's
                    privacy and safety online.
                  </p>
                  <p className="text-gray-700 mb-6" data-id="element-621">
                    We do not specifically market to children under 13.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-622">
                    Fair Information Practices
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-623">
                    The Fair Information Practices Principles form the backbone
                    of privacy law in the United States and the concepts they
                    include have played a significant role in the development of
                    data protection laws around the globe. Understanding the
                    Fair Information Practice Principles and how they should be
                    implemented is critical to comply with the various privacy
                    laws that protect personal information.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-624">
                    In order to be in line with Fair Information Practices we
                    will take the following responsive action, should a data
                    breach occur:
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-625">
                    We will notify the users via email within 7 business days.
                  </p>
                  <p className="text-gray-700 mb-6" data-id="element-626">
                    We also agree to the individual redress principle, which
                    requires that individuals have a right to pursue legally
                    enforceable rights against data collectors and processors
                    who fail to adhere to the law. This principle requires not
                    only that individuals have enforceable rights against data
                    users, but also that individuals have recourse to courts or
                    a government agency to investigate and/or prosecute
                    non-compliance by data processors.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-627">
                    CAN SPAM Act
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-628">
                    The CAN-SPAM Act is a law that sets the rules for commercial
                    email, establishes requirements for commercial messages,
                    gives recipients the right to have emails stopped from being
                    sent to them, and spells out tough penalties for violations.
                  </p>
                  <p className="text-gray-700 mb-4" data-id="element-629">
                    We collect your email address in order to:
                  </p>
                  <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-630">
                    <li data-id="element-631">
                      Send information, respond to inquiries, and/or other
                      requests or questions.
                    </li>
                    <li data-id="element-632">
                      Process orders and to send information and updates
                      pertaining to orders
                    </li>
                    <li data-id="element-633">
                      We may also send you additional information related to
                      your product and/or service.
                    </li>
                    <li data-id="element-634">
                      Market to our mailing list or continue to send emails to
                      our clients after the original transaction has occurred
                    </li>
                  </ul>
                  <p className="text-gray-700 mb-4" data-id="element-635">
                    To be in accordance with CANSPAM we agree to the following:
                  </p>
                  <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-636">
                    <li data-id="element-637">
                      NOT use false, or misleading subjects or email addresses
                    </li>
                    <li data-id="element-638">
                      Identify the message as an advertisement in some
                      reasonable way
                    </li>
                    <li data-id="element-639">
                      Include the physical address of our business or site
                      headquarters
                    </li>
                    <li data-id="element-640">
                      Monitor third party email marketing services for
                      compliance, if one is used.
                    </li>
                    <li data-id="element-641">Honor opt-out/unsubscribe requests quickly</li>
                    <li data-id="element-642">
                      Allow users to unsubscribe by using the link at the bottom
                      of each email
                    </li>
                  </ul>
                  <p className="text-gray-700 mb-6" data-id="element-643">
                    If at any time you would like to unsubscribe from receiving
                    future emails:
                  </p>
                  <p className="text-gray-700 mb-6" data-id="element-644">
                    Follow the instructions at the bottom of each email and we
                    will promptly remove you from ALL correspondence.
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-645">
                    Contacting Us
                  </h2>
                  <p className="text-gray-700 mb-4" data-id="element-646">
                    If there are any questions regarding this privacy policy you
                    may contact us using the information below:
                  </p>
                  <p className="text-gray-700 mb-2" data-id="element-647">
                    <a href="https://www.wearhaus.net" className="text-wh-teal hover:underline" data-id="element-648">
                      www.wearhaus.net
                    </a>
                  </p>
                  <p className="text-gray-700 mb-2" data-id="element-649">
                    <a href="mailto:wearhaus@wearhaus.net" className="text-wh-teal hover:underline" data-id="element-650">
                      wearhaus@wearhaus.net
                    </a>
                  </p>
                  <p className="text-gray-700 mb-2" data-id="element-651">
                    4425 West US Hwy 20, Suite 1<br data-id="element-652" />
                    LaGrange, IN 46761
                  </p>
                  <p className="text-gray-700 mb-2" data-id="element-653">Phone: 260-463-7373</p>
                  <p className="text-gray-700 mb-8" data-id="element-654">Fax: 260-463-4950</p>

                  <p className="text-sm text-gray-500 italic mt-12 pt-6 border-t border-gray-200" data-id="element-655">
                    Last Edited on 1/23/26
                  </p>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>;
}